import WithRender from "../../templates/layouts/layoutPersonalizationFullPageConfiguration.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getMatrixComplete",
      "getFactsheet",
      "getProductPartsNames",
      "getIsMobile"
    ])
  },
  methods: {
    getPPFactsheet: function (pp) {
      if (this.getFactsheet) {
        const files = this.getFactsheet[pp]?.files;
        if (!files) {
          return null;
        }
        return Object.values(files)[0]?.path ?? null;
      }
    }
  }
});
